/*       */

import { gql } from '@apollo/client';

export default gql`
    query loadAvatarQuery($id: ID!) {
        result: script(id: $id) {
            id
            name
        }
    }
`;
